import api from '@/apiManager/apiManager'

export const loginUser = data => {
  const url = '/corporate-admin/auth/login'
  return api('post', url, data, 'base')
}

export const forgotPassword = data => {
  const url = '/auth/forgot-password'
  return api('post', url, data, 'userAuth')
}

export const recoverPassword = data => {
  const url = '/auth/reset-password'
  return api('post', url, data, 'userAuth')
}
export const sharedLinkLogin = data => {
  const url = `/corporate-admin/auth/validate-corporate-temp-token?token=${data.token}`
  return api('get', url, null, 'base')
}

export const refreshAccessToken = () => {
  const userData = JSON.parse(localStorage.getItem('userData'))
  const data = {
    refreshToken: localStorage.getItem('refreshToken'),
    userName: userData.username,
  }
  const url = '/corporate-admin/auth/refresh-token'
  return api('post', url, data, 'base')
}

export const registerUser = data => {
  const url = '/auth/register'
  return api('post', url, data, 'userAuth')
}

export const checkUserExist = data => {
  const url = '/auth/social-login-check'
  return api(
    'get',
    url,
    {
      headers: {
        Authorization: `Bearer ${data.id_token}`,
      },
    },
    'userAuth',
  )
}

export const newLoginUser = data => {
  const url = '/auth/login'
  return api('post', url, data, 'userAuth')
}

// Signup OTPs go out without a token. With one (say, a stale login left in
// localStorage) the backend files the OTP under that account instead of under
// signup, and verifying it would mark that other account's email verified.
const signupOtpConfig = { headers: { Authorization: '' } }

export const sendOtp = data => {
  const url = '/auth/send-otp'
  return api('post', url, data, 'userAuth', signupOtpConfig)
}

export const verifyOtp = data => {
  const url = '/auth/verify-otp'
  return api('post', url, data, 'userAuth', signupOtpConfig)
}

export const syncSocialMediaUser = data => {
  const url = '/auth/social-login'
  return api(
    'get',
    url,
    {
      headers: {
        Authorization: `Bearer ${data.id_token}`,
      },
    },
    'userAuth',
  )
}
